const MESSAGES = {
  PRODUCT_EMPTY_MSG: 'The product is running out of stock',
  ADD_CART_SUCCESS_MSG: 'The item is added to your cart!',
  ADD_CART_FAILED_MSG: 'This item can\'t be added right now!',
  ADD_PRODUCT_SUCCESS_MSG: 'Successfully added the product!',
  ADD_PRODUCT_FAILED_MSG: 'Failed to add the product!',
  UPDATE_ITEM_SUCCESS_MSG: 'Successfully updated the product!',
  UPDATE_ITEM_FAILED_MSG: 'The item cannot be updated right now!',
  INCREMENT_CART_FAILED_MSG: 'You cannot add more items!',
  INCREMENT_CART_SUCCESS_MSG: 'You\'ve bought one more of this item!',
  DELETE_CART_SUCCESS_MSG: 'The item is deleted!',
  DELETE_CART_FAILED_MSG: 'This item can\'t be deleted right now!',
  DELETE_PRODUCT_SUCCESS_MSG: 'Successfully deleted the product!',
  DELETE_PRODUCT_FAILED_MSG: 'Failed to delete the product!',
  DELETE_CONFIRMATION_MSG: 'Are you sure that you want to delete this item?',
  ADD_PRODUCT_HEADING: 'Add Product Page',
  EDIT_PRODUCT_HEADING: 'Edit Product Page',
  EMPTY_CART_HEADING: 'Your cart is empty.',
  EMPTY_PRODUCT_LIST_HEADING: 'No products here yet.'
}

export default MESSAGES;
